<template>
    <div class="logout"></div>
</template>

<script>
export default {
    name: 'logout',
}
</script>
